export default __webpack_public_path__ + "static/media/chumbo-vertical.2a3d9dab.png";